import { type AutomationRun } from '~/hooks/queries/automations/usePrivateAutomationRunsList';

export const formatAutomationRunReason = (skipReason: string | null) => skipReason?.replaceAll('_', ' ') ?? '';

const formatStatusWithOptionalReason = ({
  baseLabel,
  skipReason,
}: {
  baseLabel: string;
  skipReason: string | null;
}) => {
  const reason = formatAutomationRunReason(skipReason);

  return reason === '' ? baseLabel : `${baseLabel} — ${reason}`;
};

export const getAutomationRunStatusLabel = (run: Pick<AutomationRun, 'skipReason' | 'status'>) => {
  const { skipReason, status } = run;

  switch (status) {
    case 'skipped':
      return formatStatusWithOptionalReason({ baseLabel: 'Skipped', skipReason });
    case 'completed':
      return 'Completed';
    case 'failed':
      return formatStatusWithOptionalReason({ baseLabel: 'Failed', skipReason });
    case 'started':
      return 'Started';
    default: {
      const exhaustiveStatus: never = status;

      return exhaustiveStatus;
    }
  }
};

export const canOpenAutomationRunSession = (run: Pick<AutomationRun, 'sessionId' | 'status'>) => {
  if (run.sessionId === null) {
    return false;
  }

  return run.status === 'started' || run.status === 'completed' || run.status === 'failed';
};

export const shouldShowAutomationRunScheduleTrigger = (run: Pick<AutomationRun, 'status'>) => run.status !== 'skipped';
